import React from "react";
import { format, isSameMinute } from "date-fns";

const DateDisplay = ({ currentViewDate = new Date(), onReset }) => {
	// Compare exact times instead of just the day
	const isCurrentTime = isSameMinute(currentViewDate, new Date());

	return (
		<div
			className="p-4 border-b border-gray-200 dark:border-gray-700"
			onClick={!isCurrentTime ? onReset : undefined}
		>
			<h2
				className={`inline-block text-lg font-semibold text-gray-900 dark:text-white 
        ${
					!isCurrentTime
						? "cursor-pointer border-2 border-blue-500/50 rounded px-2 hover:bg-gray-50 dark:hover:bg-gray-800/50"
						: ""
				}`}
			>
				{isCurrentTime ? "Today's Schedule" : "Reset to Now"}
			</h2>
			<p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
				{format(currentViewDate, "EEEE, MMMM d")}
			</p>
		</div>
	);
};

export default DateDisplay;
